import React, { Component } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import { Breadcrumb, Button, message, Input, Select, DatePicker, Modal } from "antd";
import { Loader, Message } from "semantic-ui-react";
import OperationRecordDetail from "../OperationRecordDetail";
import moment from "moment";

class IndividualGrid extends Component {
  constructor(props) {
    super(props);
    const that = this;
    this.state = {
      // columnDefs: props.restrictedSecurityRuleGridColumns,
      columnDefs: [
        {
          field: "participant",
          headerName: "Participant*",
          cellClass: "non-number",
          width: 200,
          cellRenderer: "agGroupCellRenderer",
          checkboxSelection: true,
        },
        {
          field: "title",
          headerName: "Title*",
          cellClass: "non-number",
          width: 300,
        },
        {
          field: 'year',
          headerName: "Year",
          cellClass: 'non-number',
          width: 90,
        },
        {
          field: "starttime",
          headerName: "Start Time",
          cellClass: "non-number",
          width: 150,
          sort: "desc",
        },
        {
          field: "endtime",
          headerName: "End Time",
          cellClass: "non-number",
          width: 150,
        },
        {
          field: "type",
          headerName: "Type",
          cellClass: "non-number",
          width: 100,
        },
        {
          field: "totlescore",
          headerName: "Credit",
          cellClass: "non-number",
          width: 100,
        },
        {
          field: "progress",
          headerName: "Participation Rate",
          cellClass: "non-number",
          width: 200,
        },
        {
          field: "missedComments",
          headerName: "Missed Comments",
          cellClass: "non-number",
          width: 160,
          valueGetter: (params) => {
            const detailList = Array.isArray(params.data.detialList)
              ? params.data.detialList
              : [params.data];
            return detailList.filter((session) =>
              (String(session.state || "").toLowerCase() === "confirm" || String(session.state || "").toLowerCase() === "finish") &&
              !(session.note || "").trim(),
            ).length;
          },
        },
        {
          field: "score",
          headerName: "Score",
          cellClass: "non-number",
          width: 100,
        },
        {
          field: "required",
          headerName: "Mandatory or Optional",
          cellClass: "non-number",
          width: 200,
        },
        // {
        //   field: 'optional',
        //   headerName: "Optional",
        //   cellClass: 'non-number',
        //   width: 100,
        // },
      ],
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        resizable: true,
      },
      rowSelection: "single",
      rowClassRules: {
        MarkBackgroundRede: function (params) {
          // if(params.data.status === 'New') {
          return (
            params.data.required === "M" &&
            params.data.progress.split("/")[0] === "0"
          );
          // } alertFlag  limitFlag  1 表示出警
        },
      },
      context: { componentParent: this },
      frameworkComponents: {},
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: [
            {
              field: "id",
              headerName: "id",
              cellClass: "non-number",
              width: 120,
              cellRenderer: "agGroupCellRenderer",
              headerCheckboxSelection: true,
              headerCheckboxSelectionFilteredOnly: true,
              checkboxSelection: true,
            },
            // {field: 'title', headerName: 'title', cellClass: 'non-number', width: 150},
            {
              field: "starttime",
              headerName: "Training Date*",
              cellClass: "non-number",
              width: 100,
              cellRenderer: (params) => {
                // const commaNum = date(params.data.starttime).format('0,0.00');
                // params.data.starttime
                return params.data.starttime.substring(0, 10);
              },
              sort: "desc",
            },
            // {field: 'required', headerName: 'required', cellClass: 'non-number', width: 120},
            // {
            //     field: 'participant',
            //     headerName: "Participant*",
            //     cellClass: 'non-number',
            //     width: 200,
            // },
            {
              field: "title",
              headerName: "title",
              cellClass: "non-number",
              width: 150,
            },

            {
              field: "comperename",
              headerName: "Coach",
              cellClass: "non-number",
              width: 200,
            },

            {
              field: "subtitle",
              headerName: "Sub title",
              cellClass: "non-number",
              width: 150,
            },
            {
              field: "note",
              headerName: "What did you learn",
              cellClass: "non-number",
              width: 300,
            },
            {
              field: "comments",
              headerName: "Coach's comments",
              cellClass: "non-number",
              width: 300,
            },
            {
              field: "filepath",
              headerName: "Attachment",
              cellClass: "non-number",
              width: 300,
              cellRenderer: this.sendHistoryAttachementCellRender,
            },
            {
              field: "signin",
              headerName: "Sumitter*",
              cellClass: "non-number",
              width: 150,
            },
            //   {
            //     field: 'feedbackComments',
            //     headerName: "Feedback",
            //     cellClass: 'non-number',
            //     width: 150,
            // },
            // {
            //     field: 'feedbackScore',
            //     headerName: "feedback Score",
            //     cellClass: 'non-number',
            //     width: 150,
            // },
          ],
          suppressRowClickSelection: true,
          suppressAggFuncInHeader: true,
          defaultColDef: { sortable: true, resizable: true, filter: true },
          animateRows: true,
          immutableData: false,
          onSelectionChanged(event) {
            let rowNodeArray = event.api.getSelectedNodes();
            let cptRcdDataArray = rowNodeArray.map((rowNode) => rowNode.data);
            that.props.selectMeetingAndTrainingReviewInfo(cptRcdDataArray);
          },
          onRowClicked(event) {
            const selectedRcd = event.data;
            that.props.doOperationRecordAction({
              action: "SHOW_DETAIL",
              detail: selectedRcd,
            });
          },
        },

        getDetailRowData: function (params) {
          params.successCallback(params.data.detialList);
        },
        getRowNodeId: function (data) {
          return data.id;
        },
        template:
          '<div style="height: 100%; background-color: #edf6ff; padding: 20px; box-sizing: border-box;">' +
          '  <div style="height: 10%; margin-bottom: 10px; font-weight: bold;">  Detail</div>' +
          '  <div ref="eDetailGrid" style="height: 90%;"></div>' +
          "</div>",
      },
      selectedRow: null,
      iconLoading: false,
      summaryCommentModal: {
        visible: false,
        participant: "",
        analyst: "",
        summary: "",
        records: [],
        totalSessions: 0,
        totalComments: 0,
        missedComments: 0,
        hasParticipant: false,
      },
    };
    this.isUnmounted = false;
    this.restrictedRuleLoadSeq = 0;
  }
  //   onRowClicked = (event) => {
  //     const selectedRcd = event.data;
  //     this.props.doOperationRecordAction({action:'SHOW_DETAIL', detail: selectedRcd});
  // }
  sendHistoryAttachementCellRender = (node) => {
    const attachement = node.data.filepath;
    if (!attachement) {
      return "";
    }
    const attArray = attachement.split(";");
    const retElement = document.createElement("div");
    let first = true;
    attArray.forEach((e) => {
      if (!first) {
        retElement.append(" | ");
      }
      first = false;

      const url = this.props.meetingAndTrainingReviewDownloadUrl + "/" + e;
      const link = document.createElement("a");
      link.innerText = e;
      link.target = "_blank";
      link.href = url;
      retElement.appendChild(link);
    });
    return retElement;
  };
  componentDidMount() {
    this.loadRestrictedRules({
      includeState: true,
    });
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  loadRestrictedRules = ({ includeState = false } = {}) => {
    const { year, title, type, participant, state, startTime } =
      this.props.meetingAndTrainingReviewQueryFields;
    const person = participant;
    const loadSeq = ++this.restrictedRuleLoadSeq;
    this.setState({ iconLoading: true });
    const loadAction = this.props.loadRestrictedRuleList({
      year: !!year ? (moment.isMoment(year) ? year.year() : year) : undefined,
      title,
      type,
      participant,
      starttime: !!startTime ? startTime.format("YYYY-MM-DD") : null,
      person,
      state: includeState ? state : undefined,
    });

    if (loadAction && typeof loadAction.then === "function") {
      loadAction.then(
        () => this.stopIconLoading(loadSeq),
        () => this.stopIconLoading(loadSeq),
      );
    } else {
      this.stopIconLoading(loadSeq);
    }
  };

  stopIconLoading = (loadSeq) => {
    if (!this.isUnmounted && loadSeq === this.restrictedRuleLoadSeq) {
      this.setState({ iconLoading: false });
    }
  };

  getRowNodeId = (data) => {
    return data.id;
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.closeToolPanel();
  };

  refreshData = () => {
    const { year, title, participant, type, startTime, endTime, speaker } =
      this.props.meetingAndTrainingReviewQueryFields;
    const person = participant;
    const loadSeq = ++this.restrictedRuleLoadSeq;
    this.setState({ iconLoading: true });
    const loadAction = this.props.loadRestrictedRuleList({
      year: !!year ? (moment.isMoment(year) ? year.year() : year) : undefined,
      title,
      person,
      type,
      starttime: !!startTime ? startTime.format("YYYY-MM-DD") : null,
      endTime: !!endTime ? endTime.format("YYYY-MM-DD") : null,
      speaker,
    });

    if (loadAction && typeof loadAction.then === "function") {
      loadAction.then(
        () => this.stopIconLoading(loadSeq),
        () => this.stopIconLoading(loadSeq),
      );
    } else {
      this.stopIconLoading(loadSeq);
    }
  };

  addBtnClick = () => {
    this.props.openRestrictedRuleDialog("NEW", {
      isFundBookMatched: 0,
    });
  };

  updateBtnClick = () => {
    const { selectedRow } = this.state;
    if (selectedRow) {
      this.props.openRestrictedRuleDialog("EDIT", selectedRow);
    }
  };

  onSelectionChanged = (event) => {
    var rowNodeArray = event.api.getSelectedNodes();
    var restrictedSecurityRequestArray = rowNodeArray.map(
      (rowNode) => rowNode.data,
    );

    this.setState({
      selectedRow: restrictedSecurityRequestArray[0],
    });
  };

  getLearningCommentsForParticipantRow = (participantRow) => {
    if (!participantRow) {
      return [];
    }

    const detailList = Array.isArray(participantRow.detialList)
      ? participantRow.detialList
      : [];
    const candidateRecords = detailList.length ? detailList : [participantRow];
    return candidateRecords.reduce((records, record) => {
      const note = (record.note || "").trim();
      records.push({
        title: record.title || participantRow.title || "",
        subtitle: record.subtitle || participantRow.subtitle || "",
        starttime: record.starttime || participantRow.starttime || "",
        note,
      });

      return records;
    }, []).sort((a, b) => {
      const bTime = b.starttime ? moment(b.starttime).valueOf() : 0;
      const aTime = a.starttime ? moment(a.starttime).valueOf() : 0;
      return bTime - aTime;
    });
  };

  buildSummaryCommentModalState = (participantRow, visible = true) => {
    if (!participantRow) {
      return {
        visible,
        participant: null,
        analyst: "",
        summary: "Please select a participant row to summarize.",
        records: [],
        hasParticipant: false,
      };
    }

    const participant = participantRow.participant || "";
    const analyst = participantRow.analyst || participantRow.participant || "";
    const records = this.getLearningCommentsForParticipantRow(participantRow);
    const totalSessions = records.length;
    const totalComments = records.filter((record) => record.note).length;
    const missedComments = totalSessions - totalComments;

    return {
      visible,
      participant,
      analyst,
      summary: `${totalComments} learning comment(s) are available for review.`,
      records,
      totalSessions,
      totalComments,
      missedComments: missedComments,
      hasParticipant: true,
    };
  };

  openSummaryCommentModal = () => {
    const { selectedRow } = this.state;
    if (!selectedRow) {
      message.warning("Please select one participant row first.");
      return;
    }

    this.setState({
      summaryCommentModal: this.buildSummaryCommentModalState(selectedRow),
    });
  };

  closeSummaryCommentModal = () => {
    this.setState((prevState) => ({
      summaryCommentModal: {
        ...prevState.summaryCommentModal,
        visible: false,
      },
    }));
  };

  getRScore = (array) => {
    if (array.length > 0) {
      let rArray = array
        .filter((r) => r.required === "M")
        .reduce(function (prev, cur) {
          return parseInt(cur.score) + prev;
        }, 0);
      return rArray;
    } else {
      return 0;
    }
  };

  getOScore = (array) => {
    if (array.length > 0) {
      let rArray = array
        .filter((r) => r.required === "O")
        .reduce(function (prev, cur) {
          return parseInt(cur.score) + prev;
        }, 0);
      return rArray;
    } else {
      return 0;
    }
  };
  onInputChange = ({ name, value }) => {
    if (!value) {
      value = null;
    } else if (["year", "startTime", "endTime"].includes(name)) {
      if (!moment.isMoment(value)) {
        value =
          name === "year"
            ? moment(value, "YYYY", true)
            : moment(value, "YYYY-MM-DD", true);
      }
    }
    this.props.onQueryInputChange({ name, value });
  };

  render() {
    const {
      restrictedRuleList,
      typeOptions,
      instituteUserAccountOptions,
      className = "grid-wrapper",
    } = this.props;

    const { iconLoading, summaryCommentModal } = this.state;
    const { participant, startTime, endTime, speaker, type, year } =
      this.props.meetingAndTrainingReviewQueryFields;
    const name = participant;

    const isShow = name !== null && name !== "";

    let filterRestrictedSecArray = restrictedRuleList.filter((rel) =>
      rel.participant.includes(name),
    );
    const detailShow = filterRestrictedSecArray.length > 0 ? true : false;
    const rScore = this.getRScore(filterRestrictedSecArray);
    const oScore = this.getOScore(filterRestrictedSecArray);
    //style={{height: '100px'}}
    return (
      <div className="MeetingAndTrainingReviewGrid">
        <div className="operationBar">
          <div className="breadcrumbWrapper">
            <Breadcrumb>
              <Breadcrumb.Item> Search by:</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          {/* <Input 
              allowClear={true}
              placeholder="Participant Name"
              size="small"
              style={{ width: 150, marginLeft: 10 }}
              onPressEnter={this.refreshBtnOnClicked}
              onChange={(event) => {
                  this.onInputChange({ name: 'participant', value: event.target.value })
              }} 
          /> */}
          <Select
            allowClear
            showSearch
            style={{ width: 200, marginLeft: 10 }}
            value={participant}
            onChange={(val) => {
              this.onInputChange({ name: "participant", value: val });
            }}
            placeholder="Select participant"
          >
            {instituteUserAccountOptions}
          </Select>
          <Select
            allowClear
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            value={type}
            onChange={(val) => {
              this.onInputChange({ name: "type", value: val });
            }}
            placeholder="type"
          >
            {typeOptions}
          </Select>

          <DatePicker
            allowClear={true}
            mode="year"
            format="YYYY"
            size="small"
            style={{ width: 120, marginLeft: 10 }}
            placeholder="Year"
            value={year}
            onChange={(yearValue) => {
              this.onInputChange({ name: "year", value: yearValue });
            }}
            onPanelChange={(yearValue) => {
              this.onInputChange({ name: "year", value: yearValue });
            }}
          />

          <DatePicker
            allowClear={true}
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder=" Date Start"
            value={startTime}
            onChange={(startTime, dateString) => {
              this.onInputChange({ name: "startTime", value: dateString });
            }}
          />
          <DatePicker
            allowClear={true}
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder="Date End"
            value={endTime}
            onChange={(endTime, dateString) => {
              this.onInputChange({ name: "endTime", value: dateString });
            }}
          />
          <Input
            allowClear={true}
            placeholder="Speaker"
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            value={speaker}
            onPressEnter={this.refreshBtnOnClicked}
            onChange={(event) => {
              this.onInputChange({
                name: "speaker",
                value: event.target.value,
              });
            }}
          />
          <Button
            onClick={this.refreshData}
            loading={iconLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />
          <Button
            onClick={this.openSummaryCommentModal}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            type="primary"
          >
            Summarize Comment
          </Button>
          {/* <Button 
            onClick={this.refreshData} 
            size='small'
            className='positive-button'>
            
          </Button> */}
        </div>

        <div className="operationBar">
          {detailShow && (
            <Message negative>
              <Message.Header>
                {name} Mandatory Score- {rScore}, Optional Score- {oScore}.
              </Message.Header>
            </Message>
          )}
        </div>

        <div
          className={`ag-theme-balham ${className}`}
          style={{ height: "85%" }}
        >
          {iconLoading ? (
            <Loader active content="Loading..." />
          ) : (
            <AgGridReact
              // properties
              columnDefs={this.state.columnDefs}
              rowData={restrictedRuleList}
              defaultColDef={this.state.defaultColDef}
              rowSelection={this.state.rowSelection}
              rowClassRules={this.state.rowClassRules}
              animateRows={true}
              immutableData={false}
              resizable={true}
              sideBar={true}
              getRowNodeId={this.getRowNodeId}
              context={this.state.context}
              frameworkComponents={this.state.frameworkComponents}
              // master/detail
              masterDetail={true}
              detailCellRendererParams={this.state.detailCellRendererParams}
              // events
              onGridReady={this.onGridReady}
              onSelectionChanged={this.onSelectionChanged}
            />
          )}
        </div>
        <OperationRecordDetail {...this.props} />
        <Modal
          title={
            summaryCommentModal.participant
              ? `Comment Summary - ${summaryCommentModal.participant}`
              : "Comment Summary"
          }
          visible={summaryCommentModal.visible}
          onCancel={this.closeSummaryCommentModal}
          footer={[
            <Button key="close" onClick={this.closeSummaryCommentModal}>
              Close
            </Button>,
          ]}
          width={760}
        >
          {/* <p>{summaryCommentModal.summary}</p> */}
          <div>
            <div>Total Sessions: {summaryCommentModal.totalSessions}</div>
            <div>Total Comments: {summaryCommentModal.totalComments}</div>
            <div>Missed Comments: {summaryCommentModal.missedComments}</div>
            {/* <div>Analyst: {summaryCommentModal.analyst || ""}</div> */}
          </div>
          {summaryCommentModal.hasParticipant &&
            summaryCommentModal.records.length > 0 && (
              <div style={{ maxHeight: 500, overflowY: "auto", marginTop: 16 }}>
                <strong>What did you learn</strong>
                {summaryCommentModal.records.map((record, index) => (
                  <div
                    key={`${record.title}-${record.starttime}-${index}`}
                    style={{ marginTop: 10 }}
                  >
                    {(record.title || record.subtitle || record.starttime) && (
                      <div style={{ color: "#888" }}>
                        {[record.title, record.subtitle, record.starttime]
                          .filter(Boolean)
                          .join(" - ")}
                      </div>
                    )}
                    <div>{record.note || "---"}</div>
                  </div>
                ))}
              </div>
            )}
        </Modal>
      </div>
    );
  }
}

export default IndividualGrid;
